export const heroBannerSliderListSelector = store => store.heroBanner.slider;
export const heroBannerListSelector = store => store.heroBanner.banner;
export const heroBannerGroupListSelector = store => store.heroBanner.group_banner;
export const isLoadingHeroBannerSelector = store => store.heroBanner.isLoading;
export const errorHeroBanner = store => store.heroBanner.error;
